import { addToDebugData, DealerPlacementIds } from '@wix/package-picker-shared';
import { normalizeDealerOffers } from '../dealer.utils';
export const getAcceptedPaymentMethodsQueryFn = async _ref => {
  var _firstOffer$asset;
  let {
    httpClient,
    request
  } = _ref;
  const {
    siteId,
    siteAuthorizationType
  } = request;
  const {
    DealerApiClient
  } = await import('../dealer.api-client');
  const {
    listOffers
  } = DealerApiClient.queries({
    httpClient
  });
  const placementId = DealerPlacementIds.ACCEPTED_PAYMENT_METHODS;
  const offers = await listOffers({
    placementId,
    siteId,
    siteAuthorizationType
  });
  addToDebugData({
    dealerAcceptedPaymentMethods: {
      offers,
      request: {
        ...request,
        placementId
      }
    }
  });
  const offersArray = normalizeDealerOffers(offers);
  if (offersArray.length === 0) {
    return {
      paymentMethods: undefined
    };
  }
  const firstOffer = offersArray[0];
  const creative = (_firstOffer$asset = firstOffer.asset) == null ? void 0 : _firstOffer$asset.creative;
  if (!creative || !creative.paymentMethods) {
    return {
      paymentMethods: undefined
    };
  }
  const paymentMethodsArray = creative.paymentMethods.split(',').map(method => method.trim()).filter(method => method.length > 0);
  return {
    paymentMethods: paymentMethodsArray.length > 0 ? paymentMethodsArray : undefined
  };
};
//# sourceMappingURL=getAcceptedPaymentMethods.query.js.map